import angular from 'angular';
import { EntityManagerService } from 'src/app/core';
import _ from 'lodash';

angular.module('itemsNew', ['application']).config(["$stateProvider", "$translatePartialLoaderProvider", function($stateProvider: any, $translatePartialLoaderProvider: any) {
    // $translatePartialLoaderProvider.addPart('items');
    
    $stateProvider.state('app.new.items', {
        url: '/items-new',
        redirectTo: 'app.new.items.showcase',
        template:`<items-module></items-module>`,
        params: {
            itemsQuery: null,
            scrollIndex: null
        }
    });


    // ITEMS
    $stateProvider.state('app.new.items.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.new', {
        url: '/new',
        template: `<item-details 
                    [item]="$resolve.item">
                </item-details>`,
        resolve: {
            item: function() {
                return undefined;
            },
        }
    });

    $stateProvider.state('app.new.items.details', {
        url: '/details/:itemId',
        template: `<item-details 
                    [item]="$resolve.item"
                    [item-stock]="$resolve.itemStock"
                    >
                </item-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            item: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.items.fetchOneOnline($stateParams.itemId);
            }],
            itemStock: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.stock.fetchCollectionOffline({ item_id: _.toInteger($stateParams.itemId) }).then(function(results) {
                    return _.head(results) || {};
                });
            }]
        }
    });


    // CATEGORIES
    $stateProvider.state('app.new.items.categories', {
        url: '/categories',
        redirectTo: 'app.new.items.categories.showcase',
        // resolve: {
        //     printers: ["entityManager", function(entityManager: EntityManagerService) {
        //         return entityManager.printers.fetchCollectionOffline();
        //     }]
        // }
    });


    $stateProvider.state('app.new.items.categories.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.categories.new', {
        url: '/new',
        template: `<category-details 
                    [category]="$resolve.category"
                </category-details>`,
        resolve: {
            category: function() {
                return undefined;
            }
        }
    });

    $stateProvider.state('app.new.items.categories.details', {
        url: '/details/:categoryId',
        template: `<category-details 
                    [category]="$resolve.category">
                </category-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            category: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.categories.fetchOneOnline($stateParams.categoryId);
            }]
        }
    });



    // COMPONENTS
    $stateProvider.state('app.new.items.components', {
        url: '/components',
        redirectTo: 'app.new.items.components.showcase'
    });

    $stateProvider.state('app.new.items.components.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.components.new', {
        url: '/new',
        template: `<component-details 
                    [component]="$resolve.component">
                </component-details>`,
        resolve: {
            component: function() {
                return undefined;
            }
        }
    });

    $stateProvider.state('app.new.items.components.details', {
        url: '/details/:componentId',
        template: `<component-details 
                    [component]="$resolve.component">
                </component-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            component: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.components.fetchOneOnline($stateParams.componentId);
            }]
        }
    });




    // RAW MATERIALS
    $stateProvider.state('app.new.items.raw-materials', {
        url: '/raw-materials',
        redirectTo: 'app.new.items.raw-materials.showcase'
    });

    $stateProvider.state('app.new.items.raw-materials.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.raw-materials.new', {
        url: '/new',
        template: `<raw-material-details 
                    [raw-material]="$resolve.rawMaterial">
                </raw-material-details>`,
        resolve: {
            rawMaterial: function() {
                return undefined;
            }
        }
    });

    $stateProvider.state('app.new.items.raw-materials.details', {
        url: '/details/:rawMaterialId',
        template: `<raw-material-details 
                    [raw-material]="$resolve.rawMaterial">
                </raw-material-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            rawMaterial: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.rawMaterials.fetchOneOnline($stateParams.rawMaterialId);
            }]
        }
    });





    // DEPARTMENTS
    $stateProvider.state('app.new.items.departments', {
        url: '/departments',
        redirectTo: 'app.new.items.departments.showcase'
    });

    $stateProvider.state('app.new.items.departments.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.departments.new', {
        url: '/new',
        template: `<department-details 
                    [department]="$resolve.department"
                    [activity-codes]="$resolve.activityCodes">
                </department-details>`,
        resolve: {
            department: function() {
                return undefined;
            },
            activityCodes: ["entityManager", function(entityManager: EntityManagerService) {;
                return entityManager.activityCodes.fetchCollectionOnline();
            }]
        }
    });

    $stateProvider.state('app.new.items.departments.details', {
        url: '/details/:departmentId',
        template: `<department-details 
                    [department]="$resolve.department"
                    [activity-codes]="$resolve.activityCodes">
                </department-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            department: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.departments.fetchOneOnline($stateParams.departmentId);
            }],
            activityCodes: ["entityManager", function(entityManager: EntityManagerService) {;
                return entityManager.activityCodes.fetchCollectionOnline();
            }],
        }
    });





    // VATS
    $stateProvider.state('app.new.items.vat-rate-management', {
        url: '/vat-rate-management',
        redirectTo: 'app.new.items.vat-rate-management.showcase'
    });

    $stateProvider.state('app.new.items.vat-rate-management.showcase', {
        url: '/showcase'
    });

    $stateProvider.state('app.new.items.vat-rate-management.new', {
        url: '/new',
        template: `<vat-rate-details 
                    [vat-rate]="$resolve.vatRate">
                </vat-rate-details>`,
        resolve: {
            vatRate: function() {
                return undefined;
            }
        }
    });

    $stateProvider.state('app.new.items.vat-rate-management.details', {
        url: '/details/:vatRateId',
        template: `<vat-rate-details 
                    [vat-rate]="$resolve.vatRate">
                </vat-rate-details>`,
        params: {
            isNew: {dynamic: true, value: null},
            id: null,
            showcaseState: null,
        },
        resolve: {
            vatRate: ["entityManager", "$stateParams", function(entityManager: EntityManagerService, $stateParams: any) {
                return entityManager.vat.fetchOneOnline($stateParams.vatRateId);
            }]
        }
    });
}]);